import { gql } from '@apollo/client';

export const TRIGGER_BUILD = gql`
  mutation TriggerBuild($input: TriggerBuildInput!) {
    triggerBuild(input: $input) {
      workflowName
      status
      message
    }
  }
`;

export const DELETE_IMAGE = gql`
  mutation DeleteImage($id: ID!, $region: String!) {
    deleteImage(id: $id, region: $region) {
      success
      message
    }
  }
`;

export const UPDATE_SCHEDULE = gql`
  mutation UpdateSchedule($input: UpdateScheduleInput!) {
    updateSchedule(input: $input) {
      name
      schedule
      enabled
    }
  }
`;

export const CREATE_IMAGE = gql`
  mutation CreateImage($input: CreateImageInput!) {
    createImage(input: $input) {
      id
      name
      status
    }
  }
`;

export const UPDATE_IMAGE = gql`
  mutation UpdateImage($input: UpdateImageInput!) {
    updateImage(input: $input) {
      id
      status
    }
  }
`;

export const TRIGGER_BUILD_MATRIX = gql`
  mutation TriggerBuildMatrix($input: BuildMatrixInput!) {
    triggerBuildMatrix(input: $input) {
      workflowName
      blueprints
      status
      message
    }
  }
`;

export const PROMOTE_IMAGE = gql`
  mutation PromoteImage($input: PromoteImageInput!) {
    promoteImage(input: $input) {
      imageId
      sourceEnv
      targetEnv
      status
      promotedAmiId
      message
    }
  }
`;

export const DEPRECATE_IMAGE = gql`
  mutation DeprecateImage($imageId: ID!, $replacedBy: String) {
    deprecateImage(imageId: $imageId, replacedBy: $replacedBy) {
      imageId
      status
      deprecatedAt
    }
  }
`;

export const SET_IMAGE_LIFECYCLE = gql`
  mutation SetImageLifecycle($input: LifecycleInput!) {
    setImageLifecycle(input: $input) {
      imageId
      retentionDays
      autoCleanup
    }
  }
`;

export const CREATE_NOTIFICATION_CONFIG = gql`
  mutation CreateNotificationConfig($input: NotificationConfigInput!) {
    createNotificationConfig(input: $input) {
      id
      channel
      events
      enabled
    }
  }
`;

export const UPDATE_NOTIFICATION_CONFIG = gql`
  mutation UpdateNotificationConfig($id: ID!, $input: NotificationConfigInput!) {
    updateNotificationConfig(id: $id, input: $input) {
      id
      channel
      events
      enabled
    }
  }
`;

export const DELETE_NOTIFICATION_CONFIG = gql`
  mutation DeleteNotificationConfig($id: ID!) {
    deleteNotificationConfig(id: $id) {
      success
      message
    }
  }
`;

// Workflow control
export const STOP_WORKFLOW = gql`
  mutation StopWorkflow($workflowName: String!) {
    stopWorkflow(workflowName: $workflowName) {
      name
      phase
      message
    }
  }
`;

export const SUSPEND_WORKFLOW = gql`
  mutation SuspendWorkflow($workflowName: String!) {
    suspendWorkflow(workflowName: $workflowName) {
      name
      phase
      message
    }
  }
`;

export const RESUME_WORKFLOW = gql`
  mutation ResumeWorkflow($workflowName: String!) {
    resumeWorkflow(workflowName: $workflowName) {
      name
      phase
      message
    }
  }
`;

export const RETRY_WORKFLOW = gql`
  mutation RetryWorkflow($workflowName: String!) {
    retryWorkflow(workflowName: $workflowName) {
      name
      phase
      message
    }
  }
`;

export const RESUBMIT_WORKFLOW = gql`
  mutation ResubmitWorkflow($workflowName: String!) {
    resubmitWorkflow(workflowName: $workflowName) {
      workflowName
      status
      message
    }
  }
`;

export const RESCAN_IMAGE = gql`
  mutation RescanImage($imageId: ID!) {
    rescanImage(imageId: $imageId) {
      workflowName
      status
      message
    }
  }
`;

// PR-3: Lineage
export const SET_IMAGE_LINEAGE = gql`
  mutation SetImageLineage($input: SetImageLineageInput!) {
    setImageLineage(input: $input) {
      imageId
      parentId
      childIds
    }
  }
`;

// PR-4: Channels
export const CREATE_CHANNEL = gql`
  mutation CreateChannel($input: CreateChannelInput!) {
    createChannel(input: $input) {
      name
      description
      autoPromote
      createdAt
    }
  }
`;

export const UPDATE_CHANNEL = gql`
  mutation UpdateChannel($input: UpdateChannelInput!) {
    updateChannel(input: $input) {
      name
      currentImageId
      currentAmiId
      updatedAt
    }
  }
`;

export const ROLLBACK_CHANNEL = gql`
  mutation RollbackChannel($name: String!, $toTimestamp: String!) {
    rollbackChannel(name: $name, toTimestamp: $toTimestamp) {
      name
      currentImageId
      currentAmiId
    }
  }
`;

export const DELETE_CHANNEL = gql`
  mutation DeleteChannel($name: String!) {
    deleteChannel(name: $name) {
      success
      message
    }
  }
`;

// PR-5: Policy Engine
export const CREATE_POLICY = gql`
  mutation CreatePolicy($input: CreatePolicyInput!) {
    createPolicy(input: $input) {
      id
      name
      severity
      enabled
    }
  }
`;

export const UPDATE_POLICY = gql`
  mutation UpdatePolicy($input: UpdatePolicyInput!) {
    updatePolicy(input: $input) {
      id
      name
      severity
      enabled
    }
  }
`;

export const DELETE_POLICY = gql`
  mutation DeletePolicy($id: ID!) {
    deletePolicy(id: $id) {
      success
      message
    }
  }
`;

// PR-8: Replication
export const REPLICATE_IMAGE = gql`
  mutation ReplicateImage($input: ReplicateImageInput!) {
    replicateImage(input: $input) {
      imageId
      sourceRegion
      replications {
        region
        status
        progress
      }
    }
  }
`;

export const RUN_SCHEDULE = gql`
  mutation RunSchedule($name: String!) {
    runSchedule(name: $name) {
      success
      workflowName
      message
    }
  }
`;
